import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed0e33dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BackBar__Inner" }
const _hoisted_2 = {
  class: "BackBar__Draggable",
  ref: "inner"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BackBar__Background" }, null, -1))
const _hoisted_4 = {
  class: "BackBar__Grid",
  ref: "grid"
}
const _hoisted_5 = { class: "BackBar__Line" }
const _hoisted_6 = { class: "BackBar__Line" }
const _hoisted_7 = { class: "BackBar__Line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackBarUI = _resolveComponent("BackBarUI")!
  const _component_Cell = _resolveComponent("Cell")!
  const _component_BackBarTutorial = _resolveComponent("BackBarTutorial")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!

  return (_openBlock(), _createBlock(_component_FocusTrap, { active: _ctx.isRewards }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["BackBar", { 'active': _ctx.isRewards, 'zoomIn': _ctx.isZoomIn }])
      }, [
        _createVNode(_component_BackBarUI, {
          onOnZoomOut: _ctx.onZoomOut,
          onOnPrevious: _ctx.onPrevious,
          onOnNext: _ctx.onNext
        }, null, 8, ["onOnZoomOut", "onOnPrevious", "onOnNext"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(6),
                  bottle: 6,
                  ref: "cell1",
                  index: 1
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(7),
                  bottle: 7,
                  ref: "cell2",
                  index: 2
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(5),
                  bottle: 5,
                  ref: "cell3",
                  index: 3
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(8),
                  bottle: 8,
                  ref: "cell4",
                  index: 4
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(9),
                  bottle: 9,
                  ref: "cell5",
                  index: 5
                }, null, 8, ["active"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(4),
                  bottle: 4,
                  ref: "cell6",
                  index: 6
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(1),
                  bottle: 1,
                  ref: "cell7",
                  index: 7
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(2),
                  bottle: 2,
                  ref: "cell8",
                  index: 8
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(3),
                  bottle: 3,
                  ref: "cell9",
                  index: 9
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(17),
                  bottle: 17,
                  ref: "cell10",
                  index: 10
                }, null, 8, ["active"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(10),
                  bottle: 10,
                  ref: "cell11",
                  index: 11
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(11),
                  bottle: 11,
                  ref: "cell12",
                  index: 12
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(12),
                  bottle: 12,
                  ref: "cell13",
                  index: 13
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(13),
                  bottle: 13,
                  ref: "cell14",
                  index: 14
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(14),
                  bottle: 14,
                  ref: "cell15",
                  index: 15
                }, null, 8, ["active"]),
                _createVNode(_component_Cell, {
                  active: _ctx.isActive(15),
                  bottle: 15,
                  ref: "cell16",
                  index: 16
                }, null, 8, ["active"])
              ])
            ], 512)
          ], 512)
        ]),
        _createVNode(_component_BackBarTutorial)
      ], 2)
    ]),
    _: 1
  }, 8, ["active"]))
}